import { TableDiffResponse } from "admin/types/interfaces/adminTableDiff";
import { useFetcher } from "~/hooks/useFetcher";

const { VITE_CATALOG_API } = import.meta.env;

/**
 * Compares Snowflake's table inventory against OpenMetadata's for `schema`. The
 * endpoint requires a schema, so no request is made until one is chosen (SWR
 * receives a null key). `include_in_sync` is always set: the endpoint omits the
 * in-sync list by default, and the page renders it as its own column.
 */
const useAdminTableDiff = (schema: string | null) => {
  const url = schema
    ? `${VITE_CATALOG_API}/admin/tables/diff?schema=${encodeURIComponent(schema)}&include_in_sync=true`
    : null;

  const { data, error, isLoading } = useFetcher<TableDiffResponse>(url);

  return {
    diff: data,
    isLoading,
    error,
  };
};

export default useAdminTableDiff;
